import classNames from 'classnames';
import type { AriaRole } from 'react';
import React from 'react';
import styles from './SVGIcon.module.scss';

export type SVGIconSize = 'small' | 'regular' | 'large' | number;

interface SVGIconProps
  extends Pick<
    React.HTMLAttributes<HTMLDivElement>,
    'onMouseEnter' | 'onMouseLeave' | 'onTouchStart' | 'onMouseDown' | 'onClick'
  > {
  children?: string | null;
  className?: string;
  inline?: boolean;
  size?: SVGIconSize;
  role?: AriaRole;
}

const SVGIcon = React.forwardRef<HTMLDivElement, SVGIconProps>(
  (
    {
      className = '',
      children = null,
      inline = false,
      size = 'regular',
      role,
      onMouseEnter,
      onMouseLeave,
      onTouchStart,
      onMouseDown,
      onClick,
    },
    ref,
  ) => {
    if (!children) return null;
    const svg = role
      ? children.replace('<svg', `<svg role="${role}"`)
      : children;

    return (
      <div
        ref={ref}
        className={classNames(styles.icon, className, {
          [styles.inline]: inline,
          [styles.large]: size === 'large',
          [styles.small]: size === 'small',
        })}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: svg }}
        style={typeof size === 'number' ? { fontSize: size } : undefined}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onTouchStart={onTouchStart}
        onMouseDown={onMouseDown}
        onClick={onClick}
      />
    );
  },
);

SVGIcon.displayName = 'SVGIcon';

export default SVGIcon;
